import React, { useEffect } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useNavigate,
  useParams,
} from "react-router-dom";

import HomeView from "../views/HomeView/HomeView";
import { Typography } from "@mui/material";
import NewTicketView from "../views/NewTicketView/NewTicketView";
import TicketView from "../views/TicketView/TicketView";
import TicketsView from "../views/TicketsView/TicketsView";
import UserSettingsView from "../views/UserSettingsView/UserSettingsView";
import UserPasswordResetView from "../views/UserPasswordResetView/UserPasswordResetView";
import TicketSuccessView from "../views/TicketSuccessView/TicketSuccessView";
import NotFoundView from "../views/NotFoundView/NotFoundView";
import IntakeView from "../views/IntakeView/IntakeView";
import IntakeReturnView from "../views/IntakeReturnView/IntakeReturnView";
import UserDocumentsView from "../views/UserDocumentsView/UserDocumentsView";
import UserMessagesView from "../views/UserMessagesView/UserMessagesView";

/** Ken's unhyphenated spelling → the canonical `/non-cdl/:tier`. See DefaultRouter for the why. */
const NonCdlAliasRedirect = () => {
  const { tier } = useParams();
  return <Navigate to={`/non-cdl/${tier ?? ""}`} replace />;
};

const AuthRouter = createBrowserRouter(
  [
    {
      path: "/",
      element: <HomeView />,
    },
    {
      path: "/home",
      element: <HomeView />,
    },
    {
      path: "/new-ticket",
      element: <NewTicketView />,
    },
    {
      path: "/tickets",
      element: <TicketsView />,
    },
    {
      path: "/ticket",
      element: <TicketView />,
    },
    {
      path: "/ticket-success",
      element: <TicketSuccessView />,
    },
    {
      path: "/settings",
      element: <UserSettingsView />,
    },
    {
      path: "/reset-password",
      element: <UserPasswordResetView />,
    },
    {
      // Same as in DefaultRouter: a signed-in visitor must see the same intake page as anyone else,
      // and staff need to be able to open it to check what a client is shown.
      path: "/non-cdl/:tier",
      element: <IntakeView product="non-cdl" />,
    },
    {
      // Ken's Aug 5 button map spells it without the hyphen. Redirects onto the canonical path so a
      // signed-in visitor following one of those buttons lands where everyone else does.
      path: "/noncdl/:tier",
      element: <NonCdlAliasRedirect />,
    },
    {
      path: "/cdl/:tier",
      element: <IntakeView product="cdl" />,
    },
    {
      // Registered here as well as in DefaultRouter, for the same reason the intake page is: an
      // existing client buying a second case is signed in, and the materialiser attaches that case
      // to them rather than making a new client. Their return from Stripe must not hit "*".
      path: "/thank-you",
      element: <IntakeReturnView outcome="paid" />,
    },
    {
      path: "/received",
      element: <IntakeReturnView outcome="received" />,
    },
    {
      path: "documents",
      element: <UserDocumentsView />,
    },
    {
      path: "messages",
      element: <UserMessagesView />,
    },
    {
      path: "*",
      element: <NotFoundView />,
    },
  ],
  {}
);
export default AuthRouter;